module.exports = "https://www.gc-pro.gnp.com.mx/a449c0fbb438ae2b8560fcd13a1a2ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/warning_amber_24px.png
// module id = 8180
// module chunks = 0